import React, { Component } from 'react';
import userAccountsMenu from './bottom-components/user-accounts-menu.component'
import LoginWeb from "./bottom-components/login-web.component";
import ChatBar from "./bottom-components/default-chat-bar-components/chatBarComponent";
import { globalConstants } from "../constants/globalConstants";
import AlternateNumberInputComponent from "./bottom-components/alternate-number-input.component"; 
import CancelComponent from './bottom-components/cancel.component'

const bottomComponent = ({messageComp}) => {
    let {onNumberSelected,initiateScenarioAfterLogin,setBottomBarComponentState,onSkipClick,addNewMessages,afterLoginAtALaterStage,handleCancelButtonClick} = messageComp
    let {initiate_after_login_in_multiple} =  messageComp.state;
    switch(messageComp.state.bottom_comp.type){

        case globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU : 

            return (
                userAccountsMenu({
                    onNumberSelected,
                    initiateScenarioAfterLogin,
                    setBottomBarComponentState,
                    addNewMessages,
                    initiate_after_login_in_multiple})
            )

        case globalConstants.BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT : 

            return (
                <LoginWeb onSkipClick={onSkipClick} 
                        resetLoginState={messageComp.state.bottom_comp.resetLoginState}
                        afterLoginAtALaterStage={afterLoginAtALaterStage} />
            )
        case globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR : 

            return (
                <ChatBar    fieldType={messageComp.state.fieldType}
                            disableUserSubmit={messageComp.state.disableOptionClicks}
                            disableInputField = {messageComp.state.disableInputField}
                            handleUserAction={messageComp.handleUserAction}
                            handleBottomBarCompState={messageComp.handleBottomBarCompState}
                            scrollToBottom={messageComp.scrollToBottom}
                            showPopup={messageComp.showPopup}
                            showNumbersToSwitchBot={messageComp.state.showNumbersToSwitchBot}
                            disableNumbersToSwitchBot={messageComp.disableNumbersToSwitchBot}
                            responseAwaiting={messageComp.state.responseAwaiting}
                            onSwitchNumber={messageComp.onSwitchNumber} />
            )
        
        case globalConstants.BOTTOM_BAR_COMPONENTS.CANCEL_COMPONENT :

            return (
                CancelComponent({
                    handleCancelButtonClick,
                })
            )
        case globalConstants.BOTTOM_BAR_COMPONENTS.DFF_FORM_COMPONENT :

            return (
                <AlternateNumberInputComponent
                    props={messageComp.state.bottom_comp.dff_form_obj}
                    handleUserAction={messageComp.handleUserAction}
                    setBottomBarComponentState={setBottomBarComponentState}
                    onSkipClick = {onSkipClick}
            />
            )
    } 

}


export default bottomComponent


// WEBPACK FOOTER //
// ./src/components/bottom-component.js